import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

/**
 * Paystack redirects here after checkout for PFP seat subscriptions.
 * The subscription state comes from the webhook (source of truth); this
 * page just gives a friendly landing while that async event lands.
 */
export default function PracticePfpBillingReturn() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [countdown, setCountdown] = useState(4);

  useEffect(() => {
    const t = setInterval(() => setCountdown((c) => (c > 0 ? c - 1 : 0)), 1000);
    const goto = setTimeout(() => navigate('/practice'), 4000);
    return () => { clearInterval(t); clearTimeout(goto); };
  }, [navigate]);

  const reference = params.get('reference') || params.get('trxref');

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6">
      <Card className="max-w-md w-full p-8 rounded-3xl border-emerald-200 bg-gradient-to-br from-emerald-50 to-teal-50">
        <div className="flex flex-col items-center text-center gap-4">
          <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center">
            <CheckCircle2 className="w-8 h-8 text-emerald-700" />
          </div>
          <h1 className="text-2xl font-serif text-emerald-900">Thanks — payment received</h1>
          <p className="text-emerald-800">
            Your PFP seat subscription is being activated. Your Practice Admin page
            will refresh to show the seats within a few seconds.
          </p>
          {reference && (
            <p className="text-xs text-emerald-700">Reference: {reference}</p>
          )}
          <div className="flex items-center gap-2 text-sm text-stone-500 mt-2">
            <Loader2 className="w-4 h-4 animate-spin" />
            Redirecting in {countdown}s
          </div>
          <Button
            className="rounded-full bg-emerald-600 hover:bg-emerald-700 mt-2"
            onClick={() => navigate('/practice')}
            data-testid="pfp-billing-return-continue"
          >
            Continue to Practice Admin
          </Button>
        </div>
      </Card>
    </div>
  );
}
